import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";
import { ModuleSettingsCard } from "./companySystemSettings.styled";

export const WorkingHoursCard = styled(ModuleSettingsCard)``;

export const WorkingHoursHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${Spacing.md}px;
  margin-bottom: ${Spacing.md}px;
`;

export const WorkingHoursGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${Spacing.sm}px ${Spacing.md}px;
`;

export const MonthField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.sm}px;
`;

export const MonthLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue2};
`;
